import { setStatusBarStyle } from 'expo-status-bar';
import { useCallback } from 'react';

/**
 * Hook to switch the status bar color based on the input parameter.
 * @returns Callback to switch the status bar color. Accepts a boolean parameter to force dark mode.
 */
export const useSystemColorSwitch = () => {
  /**
   * Callback to switch the status bar color. Accepts a boolean parameter to force dark mode when showing an overlay component.
   */
  const toggleSystemColors = useCallback(async (forceDarkMode?: boolean) => {
    setStatusBarStyle(forceDarkMode ? 'light' : 'auto', true);
  }, []);

  return {
    toggleSystemColors
  };
};
